import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelecaoPeriodos from "./components/selecaoPeriodos";
import { useEmpreendimento } from "../FormSection/hooks/useEmpreendimento";
import { Select } from "antd";
import { useMessage } from "../../uteis/mensagens/useMessage";
import {
  CheckboxGroup,
  CheckboxLabel,
  CheckboxWrapper,
  Content,
  Form,
  Input,
  Label,
  SectionWrapper,
  SubmitButton,
  Subtitle,
  Title,
} from "./styles";
import { useCadastrarPostagem } from "../ViewGerenciarPostagens/hooks/useCadastrarPostagem";
import { PostagemData } from "../ViewGerenciarPostagens/Interface/PostagemData";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AccordionEmpreendimentos from "../ViewQueroViajar/components/accordioEmpreendimentos";
import useEmpreendimentos from "../ViewQueroViajar/hooks/useEmpreendimentos";
import { RadarLoadingOverlay } from "../FormSection/components/radarLoadingOverlay";
import LoadingCadastroSimples from "../FormSection/components/loadingCadastroSimples";
import { validaCPF } from "../../components/Globais";
import {
  hasNomeESobrenome,
  normalizeNomeCompleto,
} from "../../uteis/nomeCompleto";


type FormSectionProps = {
  tipo: string;
};

export default function FormSection({ tipo }: FormSectionProps) {
  
  //tipo: "todos" / "venda" / "periodos"/"compra"
  const navigate = useNavigate();
  const { showError, showWarning, contextHolder } = useMessage();
  const { cadastrar, isLoadingCadastro } = useCadastrarPostagem();

  const [desejaVender, setDesejaVender] = useState(false);
  const [quantidadeCotas, setQuantidadeCotas] = useState(1);
  const [telefone, setTelefone] = useState("");
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [email, setEmail] = useState("");

  const { empreendimento, isLoading } = useEmpreendimento();
  const [resortSelecionadoId, setResortSelecionadoId] = useState<
    number[] | null
  >(null);
  // Garantindo que se `empreendimento` vier undefined, não quebre
  const optionsComNovo = [...(empreendimento || [])];

  const [resortSelecionadoNome, setResortSelecionadoNome] =
    useState<string>("");

  const [resortBuscaTexto, setResortBuscaTexto] = useState("");

  const [objetivos, setObjetivos] = useState<string[]>([]);
  const [periodosSelecionados, setPeriodosSelecionados] = useState<any[]>([]);

  // Exemplo de lista de empreendimentos (ajuste conforme necessário)
  // Dentro do componente QueroViajar
  const { empreendimentos, isLoading: isLoadingEmpreendimento } =
    useEmpreendimentos(true); // ou passe parâmetros se necessário

  



  // Limpa estado quando a página carrega
  useEffect(() => {
    setObjetivos([]);
    setDesejaVender(false);
  }, []);

  useEffect(() => {
    const ultimo = localStorage.getItem("ultimoCadastro");
    if (ultimo) {
      const dados = JSON.parse(ultimo);

      setNome(dados.nome || "");
      setEmail(dados.email || "");
      setTelefone(dados.telefone || dados.celular || "");
      setCpf(dados.cpf || "");
      setQuantidadeCotas(dados.quantidadeCotas || 1);
      setDesejaVender(Boolean(dados.desejaVender || dados.tipo === "venda"));
    }
    if (tipo === "venda") {
      setDesejaVender(true);
      setObjetivos(["vender"]);
    }
    if (tipo === "compra") {
      setObjetivos(["comprar"]);
    }
  }, []);

   const definirTipoInteresse = (tipo: string) => {
  switch (tipo) {
    case "venda":
      return "DISPONIBILIZA";
    case "compra":
      return "PROCURA";
    case "periodos":
      return "DISPONIBILIZA";
    case "todos":
      return "DISPONIBILIZA"; // Pode também ser genérico, dependendo da lógica
    default:
      return "DISPONIBILIZA";
  }
};

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const nomeCompleto = normalizeNomeCompleto(nome);
    if (tipo === "compra" && !objetivos.includes("comprar")) {
      setObjetivos((prev) => [...prev, "comprar"]);
    }

    if (!hasNomeESobrenome(nomeCompleto)) {
      showWarning("Por favor, informe nome e sobrenome.");
      return;
    }

    if (!telefone || telefone.trim().length < 10) {
      showWarning("Por favor, preencha um número de telefone válido.");
      return;
    }

    const cpfDigits = cpf.replace(/\D/g, "");

    if (desejaVender && !validaCPF(cpfDigits)) {
      showWarning("Para ativar o anúncio, informe um CPF válido.");
      return;
    }

    const tipoInteresse = definirTipoInteresse(tipo);

      if (!resortSelecionadoId || resortSelecionadoId.length === 0) {
      showWarning("Por favor, escolha um empreendimento.");
      return;
    }

    const precisaPeriodo =
      objetivos.includes("alugar") || objetivos.includes("trocar");

    if (precisaPeriodo && periodosSelecionados.length === 0) {
      showWarning(
        "Você deve selecionar ao menos um período para alugar ou trocar. Selecione as datas e clique em adicionar."
      );
      return;
    }

    const marcouPeriodoSemObjetivo =
      periodosSelecionados.length > 0 &&
      !objetivos.includes("alugar") &&
      !objetivos.includes("trocar");

    if (marcouPeriodoSemObjetivo) {
      showWarning(
        "Você deve marcar 'Alugar' ou 'Trocar' ao selecionar períodos."
      );
      return;
    }

    const naoMarcouObjetivo =
      !objetivos.includes("vender") &&
      !objetivos.includes("comprar") &&
      !objetivos.includes("alugar") &&
      !objetivos.includes("trocar");

    if (naoMarcouObjetivo) {
      showWarning("Selecione o que deseja.");
      return;
    }

    if (
      desejaVender &&
      (!Number.isInteger(quantidadeCotas) || quantidadeCotas <= 0)
    ) {
      showWarning("Informe uma quantidade válida de cotas para venda.");
      return;
    }

  const dadosFormulario = {
    nome: nomeCompleto,
    email,
    telefone,
    celular: telefone,
    cpf: cpfDigits,
    tipo,
    desejaVender,
    resortSelecionadoId,
    resortSelecionadoNome,
    quantidadeCotas: quantidadeCotas,
  };

    localStorage.setItem("ultimoCadastro", JSON.stringify(dadosFormulario));


try {
  const ids =
    resortSelecionadoId && resortSelecionadoId.length > 0 ? resortSelecionadoId : [200];
    let pessoaIdCadastro: number | null = null;
    let observacoesPadrao = "";
  // const observacoesPadrao =
  //   !resortSelecionadoId || resortSelecionadoId.length === 0 ? resortBuscaTexto : "";
   // Se for empreendimento novo (ID 200), inclui nome digitado
  if (resortSelecionadoId?.[0] === 200 && resortSelecionadoNome) {
    observacoesPadrao = `Empreendimento informado: ${resortSelecionadoNome}`;
  }


      if (periodosSelecionados.length > 0) {
        for (const idEmpreendimento of ids) {
          for (const periodo of periodosSelecionados) {
            const data: PostagemData = {
              nome: nomeCompleto,
              celular: telefone,
              fonte: "Site",
              grupo: "Sem Grupo",
              idEmpreendimento,
              active: 1,
              dataDivulgacao: new Date().toISOString(),
              tipoInteresse,
              troca: objetivos.includes("trocar") ? 1 : 0,
              aluguel: objetivos.includes("alugar") ? 1 : 0,
              compra: objetivos.includes("comprar") ? 1 : 0,
              venda: desejaVender ? 1 : 0,
              dataIni: periodo?.inicio ? new Date(periodo.inicio).toISOString() : null,
              dataFim: periodo?.fim ? new Date(periodo.fim).toISOString() : null,
              observacoes: observacoesPadrao,
            };

            

            const resultadoCadastro = await cadastrar(data, objetivos);
            if (!resultadoCadastro?.sucesso) {
              showError(
                "Ocorreu um erro ao cadastrar. Tente novamente mais tarde."
              );
              return;
            }

            if (!pessoaIdCadastro && resultadoCadastro.pessoaId) {
              pessoaIdCadastro = resultadoCadastro.pessoaId;
            }
          }
        }
      } else {
        for (const idEmpreendimento of ids) {
          
          const data: PostagemData = {
            nome: nomeCompleto,
            celular: telefone,
            fonte: "Site",
            grupo: "Sem Grupo",
            idEmpreendimento,
            active: 1,
            dataDivulgacao: new Date().toISOString(),
            tipoInteresse,
            troca: objetivos.includes("trocar") ? 1 : 0,
            aluguel: objetivos.includes("alugar") ? 1 : 0,
            compra: objetivos.includes("comprar") ? 1 : 0,
            venda: desejaVender ? 1 : 0,
            dataIni: "",
            dataFim: "",
            observacoes: observacoesPadrao,
          };

          const resultadoCadastro = await cadastrar(data, objetivos);
          if (!resultadoCadastro?.sucesso) {
            showError(
              "Ocorreu um erro ao cadastrar. Tente novamente mais tarde."
            );
            return;
          }

          if (!pessoaIdCadastro && resultadoCadastro.pessoaId) {
            pessoaIdCadastro = resultadoCadastro.pessoaId;
          }
        }
      }

      if (desejaVender && !pessoaIdCadastro) {
        showError(
          "Não foi possível identificar a pessoa responsável pelo anúncio."
        );
        return;
      }

      if (pessoaIdCadastro) {
        localStorage.setItem(
          "ultimoCadastro",
          JSON.stringify({
            ...dadosFormulario,
            pessoaId: pessoaIdCadastro,
          })
        );
      }
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      showError("Ocorreu um erro ao cadastrar. Tente novamente mais tarde.");
      return;
    }

    if (desejaVender) {
      if (quantidadeCotas > 6) {
        navigate(`/contatovendapersonalizada?cotas=${quantidadeCotas}`);
      } else {
        navigate(`/pagamentovenda?cotas=${quantidadeCotas}`);
      }
    } else {
      document.location.href = "/cadastrosucesso";
    }
  };

 

 

  const nomeExiste = empreendimento?.some(
    (e) =>
      (e.label ?? "").toLowerCase() === resortBuscaTexto.trim().toLowerCase()
  );
  if (!nomeExiste && resortSelecionadoNome?.trim()) {
    optionsComNovo.push({
      label: resortSelecionadoNome,
      value: resortSelecionadoNome,
    });
  }

  const handleObjetivoChange = (value: string, checked: boolean) => {
    if (checked) {
      setObjetivos((prev) => [...prev, value]);
    } else {
      setObjetivos((prev) => prev.filter((item) => item !== value));
    }
  };

  return (

    
    <SectionWrapper id="formulario">
      {contextHolder}

       <RadarLoadingOverlay visible={isLoadingCadastro && (objetivos.includes("alugar") || objetivos.includes("trocar"))} />
       {isLoadingCadastro && !(objetivos.includes("alugar") || objetivos.includes("trocar")) && <LoadingCadastroSimples />}

     
      <Content>
        {tipo === "compra" ? (
          <Title>Cadastre-se para receber oportunidades</Title>
        ) : (
          <Title>Cadastre sua multipropriedade</Title>
        )}
        {tipo === "compra" ? (
          <Subtitle>
            Preencha o formulário abaixo e receba grandes oportunidades.
          </Subtitle>
        ) : tipo === "periodos" ? (
          <Subtitle>
            Preencha o formulário abaixo para alugar ou trocar seus períodos.
          </Subtitle>
        ) : (
          <Subtitle>
            Preencha o formulário abaixo para registrar seu interesse.
          </Subtitle>
        )}

        {tipo === "compra" ? (
          <>
            {" "}
            {isLoadingEmpreendimento ? (
              <p>Carregando empreendimentos...</p>
            ) : (
              <AccordionEmpreendimentos
                empreendimentos={empreendimentos}
                onChange={(idsSelecionados) => {
                  setResortSelecionadoId(idsSelecionados);
                }}
              />
            )}
          </>
        ) : null}

        <Form onSubmit={handleSubmit}>
          <Label>Nome Completo</Label>
          <Input
            type="text"
            placeholder="Digite seu nome"
            required
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />

          <Label>Nº Celular</Label>

          <PhoneInput
            country="br"
            value={telefone}
            onChange={(telefone) => {
              setTelefone(telefone);
            }}
            placeholder="(DDD) 90000-0000"
            inputClass="phone-input"
          />

       
          {tipo !== "compra" ? (
            <>
              {" "}
              <Label>Empreendimento</Label>
              {isLoading ? (
                <p>Carregando empreendimentos...</p>
              ) : (
                <Select
                  showSearch
                  allowClear
                  placeholder="Digite ou selecione um resort"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  value={resortSelecionadoNome || undefined}
                  onChange={(value) => {
                    const selecionado = empreendimento?.find(
                      (e) => e.value === value
                    );

                    if (selecionado) {
                      setResortSelecionadoId([selecionado.value as number]);
                      setResortSelecionadoNome(selecionado.label);
                    } else if (typeof value === "string") {
                      // Digitou novo empreendimento
                      setResortSelecionadoId([200]); // ID padrão
                      setResortSelecionadoNome(value);
                    }
                  }}
                  onSearch={(val) => {
                    setResortBuscaTexto(val);
                    if (val && !empreendimento.find((e) => e.label === val)) {
                      setResortSelecionadoId([200]);
                      setResortSelecionadoNome(val);
                    }
                  }}
                  options={optionsComNovo}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  notFoundContent={null}
                />
              )}
              {resortSelecionadoNome && (
                <div
                  style={{
                    marginTop: "0.5rem",
                    fontSize: "0.95rem",
                    color: "#333",
                  }}
                >
                  ✅ Resort selecionado:{" "}
                  <strong>{resortSelecionadoNome}</strong>
                  {resortSelecionadoId === null && (
                    <span style={{ color: "#888", marginLeft: "8px" }}>
                      (novo)
                    </span>
                  )}
                </div>
              )}
            </>
          ) : null}

          {(tipo === "periodos" || tipo === "todos") && (
            <SelecaoPeriodos
              onChange={(periodos) => {
                setPeriodosSelecionados(periodos);
              }}
            />
          )}

          {(tipo === "todos" || tipo === "periodos") && (
            <>
              {tipo === "periodos" || tipo === "todos" ? (
                <Label>O que você deseja? (pode ser mais de um)</Label>
              ) : (
                <Label>O que você deseja?</Label>
              )}
              <CheckboxGroup>
                <CheckboxLabel>
                  <input
                    type="checkbox"
                    name="objetivo"
                    value="alugar"
                    checked={objetivos.includes("alugar")}
                    onChange={(e) =>
                      handleObjetivoChange("alugar", e.target.checked)
                    }
                  />
                  Alugar períodos
                </CheckboxLabel>

                <CheckboxLabel>
                  <input
                    type="checkbox"
                    name="objetivo"
                    value="trocar"
                    checked={objetivos.includes("trocar")}
                    onChange={(e) =>
                      handleObjetivoChange("trocar", e.target.checked)
                    }
                  />
                  Trocar períodos
                </CheckboxLabel>

                {tipo !== "periodos" && (
                  <>
                    <CheckboxLabel>
                      <input
                        type="checkbox"
                        name="objetivo"
                        value="vender"
                        checked={objetivos.includes("vender")}
                        onChange={(e) => {
                          setDesejaVender(e.target.checked);
                          handleObjetivoChange("vender", e.target.checked);
                        }}
                      />
                      Vender uma cota
                    </CheckboxLabel>

                    <CheckboxLabel>
                      <input
                        type="checkbox"
                        name="objetivo"
                        value="comprar"
                        checked={objetivos.includes("comprar")}
                        onChange={(e) =>
                          handleObjetivoChange("comprar", e.target.checked)
                        }
                      />
                      Comprar uma cota
                    </CheckboxLabel>
                  </>
                )}
              </CheckboxGroup>
            </>
          )}
          {desejaVender && (
            <>
              <Label>CPF do responsável pelo anúncio</Label>
              <Input
                type="text"
                inputMode="numeric"
                maxLength={11}
                value={cpf}
                onChange={(e) =>
                  setCpf(e.target.value.replace(/\D/g, "").slice(0, 11))
                }
                placeholder="Digite os 11 números do CPF"
                required
              />

              <Label>Quantas cotas você deseja anunciar para venda?</Label>
              <Input
                type="number"
                min="1"
                max="10"
                value={quantidadeCotas}
                onChange={(e) => setQuantidadeCotas(Number(e.target.value))}
                placeholder="Ex: 1, 2, 3..."
              />
            </>
          )}
          <CheckboxWrapper>
            <label>
              <input type="checkbox" required />
              &nbsp;Li e aceito os&nbsp;
              <a
                href="https://proprietario.multicotas.com.br/termodeuso"
                target="_blank"
                rel="noopener noreferrer"
              >
                Termos de Uso
              </a>
              &nbsp;e a&nbsp;
              <a
                href="https://proprietario.multicotas.com.br/politicaprivacidade"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidade
              </a>
              .
            </label>
          </CheckboxWrapper>

          {tipo === "venda" && (
            <SubmitButton type="submit">
              📤 Cadastrar minha cota agora
            </SubmitButton>
          )}
          {(tipo === "compra" || tipo === "todos") && (
            <SubmitButton type="submit">📤 Cadastrar</SubmitButton>
          )}
          {tipo === "periodos" && (
            <SubmitButton type="submit">
              📤 Cadastrar meus períodos
            </SubmitButton>
          )}
        </Form>
      </Content>
    </SectionWrapper>
  );
}
